import { type ReduxUser, type CommunityBase } from 'models';
import { canManageCommunity } from './canManageCommunity';

export const canInviteToCommunity = ({ viewer, community }: { viewer: ReduxUser; community: CommunityBase }) =>
  community.privacy === 'public' || canManageCommunity({ viewer, community });
